import Skeleton from '@passkeys/ui/skeleton';

function FancyAmountSkeleton() {
  return <Skeleton width={128} height={32} />;
}

export default FancyAmountSkeleton;
